import {
    openModal,
    closeModal,
    setModalMsg
} from '../../actions'
import SystemModal from './SystemModal'

export default {
    showMsg: (dispatch, msg) => {
        dispatch(setModalMsg(msg))
        dispatch(openModal('system_msg'))
    },
    closeMsg: (dispatch) => {
        dispatch(closeModal('system_msg'))
    },
    showLoadMsg: (dispatch) => {
        SystemModal.showMsg(dispatch, '資料載入中...')
    },
    showLoadErrorMsg: (dispatch) => {
        SystemModal.showMsg(dispatch, '資料載入失敗...')
    },
    showSaveMsg: (dispatch) => {
        SystemModal.showMsg(dispatch, '資料儲存中...')
    },
    showSaveErrorMsg: (dispatch) => {
        SystemModal.showMsg(dispatch, '資料儲存失敗...')
    },
    showDestroyMsg: (dispatch) => {
        SystemModal.showMsg(dispatch, '資料刪除中...')
    },
    showDestroyErrorMsg: (dispatch) => {
        SystemModal.showMsg(dispatch, '資料刪除失敗...')
    },
}



// WEBPACK FOOTER //
// ./src/dashboards_redux/utils/SystemModal/SystemModal.jsx